import * as React from "react";
import * as _ from "lodash";
import { Utilities } from "../../shared/utilities";
import { IAgentData, IAppReducerAction, IEnvironment } from "../shared/model";


export const getEnvironments = (dispatch: React.Dispatch<IAppReducerAction>) => {
    const fetchEnvironments = async () => {
        try {
            const environments: IEnvironment[] = await Utilities.getFetch("api/environment/details");
            dispatch({ type: "SET_ENVIRONMENTS", environments: environments });
        } catch (e) {
            Utilities.toastError(e);
            console.error(e);
        }
    };
    return fetchEnvironments();
};

export const getAgentsWithStatus = (dispatch: React.Dispatch<IAppReducerAction>, agentGroupName: string) => {
    const fetchAgents = async () => {
        try {
            const url = `api/agent/agentsWithStatus/${encodeURIComponent(agentGroupName)}`;
            const agentsWithStatus = await Utilities.getFetch<IAgentData[]>(url);
            dispatch({ type: "SET_AGENT_GROUP_AGENTS_WITH_STATUS", agentViewModels: agentsWithStatus, agentGroupName });
        } catch (e) {
            Utilities.toastError(e);
            console.error(e);
        }
    };
    return fetchAgents();
};

export function setIsLoading(dispatch: React.Dispatch<IAppReducerAction>, isLoading: boolean) {
    dispatch({ type: "SET_ISLOADING", isLoading: isLoading });
}
